function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import Editor from "../../../../editor";
import styled from "styled-components";
import { connect as connectFormik, getIn } from "formik";
import Label from "../../../../label";
import { MutedText } from "../../../../text";
var InputContainer = styled.div(_templateObject());
var EditorComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(EditorComponent, Component);
    var _super = _createSuper(EditorComponent);
    function EditorComponent() {
        _classCallCheck(this, EditorComponent);
        return _super.apply(this, arguments);
    }
    var _proto = EditorComponent.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2, ref3;
        var _props = this.props, row = _props.row, formik = _props.formik, allowHelpText = _props.allowHelpText;
        var name = row.id;
        var value = getIn(formik.values, name);
        var error = getIn(formik.errors, name);
        var touched = getIn(formik.touched, name);
        var label = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isRequired) ? "* ".concat(row.label) : row.label;
        var helpText = allowHelpText ? row.description : "";
        var hasQuestionnaire = (ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.hasQuestionnaire;
        var tag = (ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.tag;
        if (!hasQuestionnaire) {
            var val = row.control;
            if (row.description === "Display on the Details Page Only") {
                return null;
            }
            if (val && typeof val !== "string") {
                val = val.toString();
            }
            if (val && val.trim().length !== 0) {
                return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Label, null, label.replace("[CUSTOMER FACING]", "")), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement("div", null, val));
            }
        }
        return /*#__PURE__*/ React.createElement(InputContainer, null, /*#__PURE__*/ React.createElement(Editor, {
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            value: value.value,
            name: name,
            tag: tag,
            error: touched && error,
            label: label,
            disabled: ((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.readOnly) || !hasQuestionnaire,
            hintText: row.description
        }));
    };
    EditorComponent.shouldComponentUpdate = function shouldComponentUpdate(nextProps, props) {
        var nextFormik = nextProps.formik;
        var formik = props.formik;
        var name = props.row.id;
        return getIn(formik.values, name) !== getIn(nextFormik.values, name) || getIn(formik.errors, name) !== getIn(nextFormik.errors, name) || getIn(formik.touched, name) !== getIn(nextFormik.touched, name);
    };
    return EditorComponent;
}(Component);
export default connectFormik(EditorComponent);
